import { postRequest } from "../../../services/RestServices";
import * as urls from "../../api/scheduler/url";

export const getSchedule = async (jobId, payload) => {
  try {
    return await postRequest(urls.GET_SCHEDULE + `/${jobId}`, payload);
  } catch (err) {
    return err;
  }
};
